import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

/* Loadable Libraries */
let Helmet = null;

class HbClientSideHelmet extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    seoInfo: PropTypes.object,
    helmetClientChanged: PropTypes.func,
  }

  constructor(props) {
    super(props);

    this.state = {
      helmetLoaded: false,
    }
  }

  componentDidMount() {
    this.loadableHelmet();

    const canonicalElement = document.querySelector('Link[rel="canonical"]');
    const descriptionElement = document.querySelector('meta[name="description"]');
    const prevElement = document.querySelector('Link[rel="next"]');
    const nextElement = document.querySelector('Link[rel="prev"]');
    const titleElement = document.querySelector('meta[name="title"]');

    HbClientSideHelmet.removeIfNotAddedOnClientSide(canonicalElement);
    HbClientSideHelmet.removeIfNotAddedOnClientSide(descriptionElement);
    HbClientSideHelmet.removeIfNotAddedOnClientSide(prevElement);
    HbClientSideHelmet.removeIfNotAddedOnClientSide(nextElement);
    HbClientSideHelmet.removeIfNotAddedOnClientSide(titleElement);
  }

  loadableHelmet() {
    loadable.lib(() => import('react-helmet')).load().
      then(component => {
        Helmet = component.Helmet;
        this.setState({
          helmetLoaded: true,
        })
      });
  }

  static removeIfNotAddedOnClientSide(targetElement) {
    if (targetElement && !targetElement.getAttribute('data-react-helmet')) {
      targetElement.remove();
    }
  }

  render() {
    const {
      children,
      seoInfo,
      helmetClientChanged,
      pageType,
      pageValue
    } = this.props;

    const {helmetLoaded} = this.state;

    if (!helmetLoaded) {
      return null;
    }

    return (
      <Helmet onChangeClientState={() => helmetClientChanged}>
        {pageType && <meta name='page_type' content={pageType} />}
        {pageValue && <meta name='page_value' content={pageValue} />}

        {seoInfo && <title>{seoInfo.title}</title>}

        {seoInfo && <meta name={'title'} content={seoInfo.title} />}

        {seoInfo && <meta name={'description'} content={seoInfo.description} />}

        {seoInfo && seoInfo.canonicalUrl && (
          <link rel='canonical' href={seoInfo.canonicalUrl} />
        )}

        {seoInfo && seoInfo.prev && <link rel={'prev'} href={seoInfo.prev} />}

        {seoInfo && seoInfo.next && <link rel={'next'} href={seoInfo.next} />}
        {children}
      </Helmet>
    );
  }
}

export default HbClientSideHelmet;
